import React, { useState } from 'react'
import { Box, Button, Checkbox, FormControlLabel, Radio } from '@mui/material';
import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import { bookingConfigColDefs, BookingOtherCharges, BoookingOtherDetails, cellStyles, ConsignmentDetails, GSTTypeConfig, LegalCompliance, ReceiverDetails, SenderDetails } from './Constant';
import EwayBillConfigModel from './EwayBillConfigModel';
const BookingScreenConfig = (props) => {
    const { setEditSaveData, editSaveData, handleBrnhCargoValue, updateModal, common,selEditLuggageSetting } = props
    const { loginData} = common;
    const [openEwayBillModel, setOpenEwayBillModel] = useState(false)
    const handleEwayBillConfig = () => {
        let modelData = {
            headText: "E-Way Bill",
            // BranchId: selEditBranch,
            isEdit: true,
            // BranchList: BranchDetailsList,
            // stateList: stateOptList,
            // cityList: cityOptList,
            loginData: loginData,
            // dropDownData: ModalHeaderDropDownData
        }

        return <EwayBillConfigModel modelData={modelData} updateModal={() => { setOpenEwayBillModel(false) }} setOpenEwayBillModel={setOpenEwayBillModel} selEditLuggageSetting={selEditLuggageSetting}/>
    }
    return (
        <>
            <Box display="flex" width="100%">
                {/* Left Table */}
                <TableContainer component={Paper} sx={{ display: 'flex', borderRight: '1px solid #DAEDFE', width: '100%',overflow:'visible' }} className="scrollBlue">
                    <Table stickyHeader size="small" style={{ borderRight: '1px solid #d9d9d9', width: '50%' }}>
                        <TableHead>
                            <TableRow style={{ background: '#DAEDFE' }}>
                                {bookingConfigColDefs.map((col, index) => (
                                    <TableCell
                                        key={`TH-L-${index}`}
                                        sx={{
                                            ...col.headerSx,
                                            padding: '7px 12px',
                                            backgroundColor: '#DAEDFE',
                                            fontFamily: 'Roboto',
                                            fontSize: '12px',
                                            fontWeight: '600',
                                            color: '#444444',
                                        }}
                                    >
                                        {col.headerName}
                                    </TableCell>
                                ))}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            <TableRow>
                                <TableCell colSpan={4} sx={{
                                    padding: '7px 12px',
                                    backgroundColor: '#DAEDFE',
                                    fontFamily: 'Roboto',
                                    fontSize: '12px',
                                    fontWeight: '600',
                                    color: '#444444',
                                }}>SENDER DETAILS </TableCell>
                            </TableRow>
                            {SenderDetails.map((item, index) => (
                                <TableRow >
                                    <TableCell style={{ ...cellStyles, width: '25%' }}>
                                        {item.field}
                                    </TableCell>
                                    <TableCell style={{ ...cellStyles, width: '25%', justifyContent: 'center', textAlign: "center" }}>
                                        <FormControlLabel
                                            value="end"
                                            sx={{ marginX: '0px' }}
                                            control={
                                                <Checkbox
                                                    id={`paid-${index}`}
                                                    checked={item.isRemove === 'IsSenderNoRemove'?0:editSaveData[item.isRemove] === 1}
                                                    sx={{
                                                        fontSize: '12px',
                                                        backgroundColor: 'transparent !important',
                                                        height: '36px',
                                                        verticalAlign: 'middle'
                                                    }}
                                                    disabled={item.isCompalsary || item.isRemove === 'IsSenderNoRemove'}
                                                    onChange={(event) => {
                                                        handleBrnhCargoValue(event.target.checked ? 1 : 0, item.isRemove, [item.isDisable, item.isMandatory])
                                                    }}
                                                />
                                            }
                                            labelPlacement="end"
                                        />
                                    </TableCell>
                                    <TableCell style={{ ...cellStyles, width: '25%', justifyContent: 'center', textAlign: "center" }}>
                                        <FormControlLabel
                                            value="end"
                                            sx={{ marginX: '0px' }}
                                            control={
                                                <Checkbox
                                                    id={`paidManual-${index}`}
                                                    // onChange={(e) => handleChkChange(e, index, 'AtPaidManBooking', tblNo)}
                                                    sx={{
                                                        fontSize: '12px',
                                                        backgroundColor: 'transparent !important',
                                                        height: '36px',
                                                        verticalAlign: 'middle'
                                                    }}
                                                    checked={item.isDisable === 'IsSenderNoDisable'?0:editSaveData[item.isDisable] === 1}
                                                    disabled={item.isCompalsary || item.isDisable === 'IsSenderNoDisable'}
                                                    onChange={(event) => {
                                                        handleBrnhCargoValue(event.target.checked ? 1 : 0, item.isDisable, [item.isRemove, item.isMandatory])
                                                    }}

                                                />
                                            }
                                            labelPlacement="end"
                                        />
                                    </TableCell>
                                    <TableCell style={{ ...cellStyles, width: '25%', justifyContent: 'center', textAlign: "center" }}>
                                        <FormControlLabel
                                            value="end"
                                            sx={{ marginX: '0px' }}
                                            control={
                                                <Checkbox
                                                    id={`toPay-${index}`}
                                                    sx={{
                                                        fontSize: '12px',
                                                        backgroundColor: 'transparent !important',
                                                        height: '36px',
                                                        verticalAlign: 'middle'
                                                    }}
                                                    disabled={item.isCompalsary}
                                                    checked={editSaveData[item.isMandatory] === 1 || item.isMandatory===1}
                                                    onChange={(event) => {
                                                        handleBrnhCargoValue(event.target.checked ? 1 : 0, item.isMandatory, [item.isRemove, item.isDisable])
                                                    }}

                                                />
                                            }
                                            labelPlacement="end"
                                        />
                                    </TableCell>
                                </TableRow>
                            ))}
                            <TableRow>
                                <TableCell colSpan={4} sx={{
                                    padding: '7px 12px',
                                    backgroundColor: '#DAEDFE',
                                    fontFamily: 'Roboto',
                                    fontSize: '12px',
                                    fontWeight: '600',
                                    color: '#444444',
                                }}>LEGAL COMPLIANCE</TableCell>
                            </TableRow>
                            {LegalCompliance.map((item, index) => (
                                <TableRow >
                                    <TableCell style={{ ...cellStyles, width: '25%' }}>
                                        {item.field}
                                    </TableCell>
                                    <TableCell style={{ ...cellStyles, width: '25%', justifyContent: 'center', textAlign: "center" }}>
                                        <FormControlLabel
                                            value="end"
                                            sx={{ marginX: '0px' }}
                                            control={
                                                <Checkbox
                                                    id={`paid-${index}`}
                                                    // onChange={(e) => handleChkChange(e, index, 'AtPaidBooking', tblNo)}
                                                    sx={{
                                                        fontSize: '12px',
                                                        backgroundColor: 'transparent !important',
                                                        height: '36px',
                                                        verticalAlign: 'middle'
                                                    }}
                                                    checked={editSaveData[item.isRemove] === 1}
                                                    onChange={(event) => {
                                                        handleBrnhCargoValue(event.target.checked ? 1 : 0, item.isRemove, [item.isDisable, item.isMandatory])
                                                    }}
                                                />
                                            }
                                            labelPlacement="end"
                                        />
                                    </TableCell>
                                    <TableCell style={{ ...cellStyles, width: '25%', justifyContent: 'center', textAlign: "center" }}>
                                        <FormControlLabel
                                            value="end"
                                            sx={{ marginX: '0px' }}
                                            control={
                                                <Checkbox
                                                    id={`paidManual-${index}`}
                                                    checked={editSaveData[item.isDisable] === 1}
                                                    onChange={(event) => {
                                                        handleBrnhCargoValue(event.target.checked ? 1 : 0, item.isDisable, [item.isRemove, item.isMandatory])
                                                    }}
                                                    sx={{
                                                        fontSize: '12px',
                                                        backgroundColor: 'transparent !important',
                                                        height: '36px',
                                                        verticalAlign: 'middle'
                                                    }}

                                                />
                                            }
                                            labelPlacement="end"
                                        />
                                    </TableCell>
                                    <TableCell style={{ ...cellStyles, width: '25%', justifyContent: 'center', textAlign: "center" }}>
                                        <FormControlLabel
                                            value="end"
                                            sx={{ marginX: '0px' }}
                                            control={
                                                <Checkbox
                                                    id={`toPay-${index}`}
                                                    checked={editSaveData[item.isMandatory] === 1}
                                                    onChange={(event) => {
                                                        handleBrnhCargoValue(event.target.checked ? 1 : 0, item.isMandatory, [item.isRemove, item.isDisable])
                                                    }}
                                                    sx={{
                                                        fontSize: '12px',
                                                        backgroundColor: 'transparent !important',
                                                        height: '36px',
                                                        verticalAlign: 'middle'
                                                    }}

                                                />
                                            }
                                            labelPlacement="end"
                                        />
                                    </TableCell>
                                </TableRow>
                            ))}
                            <TableRow>
                                <TableCell colSpan={4} sx={{
                                    padding: '7px 12px',
                                    backgroundColor: '#DAEDFE',
                                    fontFamily: 'Roboto',
                                    fontSize: '12px',
                                    fontWeight: '600',
                                    color: '#444444',
                                }}>EWAYBILL CONFIG</TableCell>
                            </TableRow>
                            <TableRow >
                                <TableCell style={{ ...cellStyles, width: '25%' }}>
                                    UPDATE EWAYBILL CREDENTIALS
                                </TableCell>
                                <TableCell style={{ ...cellStyles, width: '25%', justifyContent: 'center', textAlign: "center" }}>
                                    <Button
                                        id="saveSettings"
                                        style={{ margin: '0', height: "40px", width: '100%' }}
                                        className="btn add-btn"
                                        variant="contained"
                                        color="error"
                                        onClick={() => { setOpenEwayBillModel(true) }}
                                    >
                                        EWAYBILL CONFIG
                                    </Button>
                                </TableCell>
                                <TableCell style={{ ...cellStyles, width: '25%' }}>
                                    IS EWAYBILL VALIDATION?
                                </TableCell>
                                <TableCell style={{ ...cellStyles, width: '25%', justifyContent: 'center', textAlign: "center" }}>
                                    <FormControlLabel
                                        value="end"
                                        sx={{ marginX: '0px' }}
                                        control={
                                            <Checkbox
                                                // id={`toPay`}
                                                checked={editSaveData.IsEwayBillValidate === 1}
                                                onChange={(event) => {
                                                    handleBrnhCargoValue(event.target.checked ? 1 : 0, 'IsEwayBillValidate', [])
                                                }}
                                                sx={{
                                                    fontSize: '12px',
                                                    backgroundColor: 'transparent !important',
                                                    height: '36px',
                                                    verticalAlign: 'middle'
                                                }}

                                            />
                                        }
                                        labelPlacement="end"
                                    />
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell colSpan={4} sx={{
                                    padding: '7px 12px',
                                    backgroundColor: '#DAEDFE',
                                    fontFamily: 'Roboto',
                                    fontSize: '12px',
                                    fontWeight: '600',
                                    color: '#444444',
                                }}>RECEIVER DETAILS</TableCell>
                            </TableRow>
                            {ReceiverDetails.map((item, index) => (
                                <TableRow >
                                    <TableCell style={{ ...cellStyles, width: '25%' }}>
                                        {item.field}
                                    </TableCell>
                                    <TableCell style={{ ...cellStyles, width: '25%', justifyContent: 'center', textAlign: "center" }}>
                                        <FormControlLabel
                                            value="end"
                                            sx={{ marginX: '0px' }}
                                            control={
                                                <Checkbox
                                                    id={`paid-${index}`}
                                                    checked={item.isRemove==='IsReceiverNoRemove'?0:editSaveData[item.isRemove] === 1}
                                                    onChange={(event) => {
                                                        handleBrnhCargoValue(event.target.checked ? 1 : 0, item.isRemove, [item.isDisable,item.isMandatory])
                                                    }}
                                                    disabled={item.isCompalsary || item.isRemove==='IsReceiverNoRemove'}
                                                    sx={{
                                                        fontSize: '12px',
                                                        backgroundColor: 'transparent !important',
                                                        height: '36px',
                                                        verticalAlign: 'middle'
                                                    }}

                                                />
                                            }
                                            labelPlacement="end"
                                        />
                                    </TableCell>
                                    <TableCell style={{ ...cellStyles, width: '25%', justifyContent: 'center', textAlign: "center" }}>
                                        <FormControlLabel
                                            value="end"
                                            sx={{ marginX: '0px' }}
                                            control={
                                                <Checkbox
                                                    id={`paidManual-${index}`}
                                                    disabled={item.isCompalsary || item.isDisable==='IsReceiverNoDisable'}
                                                    checked={item.isDisable==='IsReceiverNoDisable'?0:editSaveData[item.isDisable] === 1}
                                                    onChange={(event) => {
                                                        handleBrnhCargoValue(event.target.checked ? 1 : 0, item.isDisable, [item.isRemove,item.isMandatory])
                                                    }}
                                                    sx={{
                                                        fontSize: '12px',
                                                        backgroundColor: 'transparent !important',
                                                        height: '36px',
                                                        verticalAlign: 'middle'
                                                    }}
                                                />
                                            }
                                            labelPlacement="end"
                                        />
                                    </TableCell>
                                    <TableCell style={{ ...cellStyles, width: '25%', justifyContent: 'center', textAlign: "center" }}>
                                        <FormControlLabel
                                            value="end"
                                            sx={{ marginX: '0px' }}
                                            control={
                                                <Checkbox
                                                    id={`toPay-${index}`}
                                                    checked={editSaveData[item.isMandatory] === 1 ||item.isMandatory==1}
                                                    disabled={item.isCompalsary}
                                                    onChange={(event) => {
                                                        handleBrnhCargoValue(event.target.checked ? 1 : 0, item.isMandatory, [item.isRemove,item.isDisable])
                                                    }}
                                                    sx={{
                                                        fontSize: '12px',
                                                        backgroundColor: 'transparent !important',
                                                        height: '36px',
                                                        verticalAlign: 'middle'
                                                    }}

                                                />
                                            }
                                            labelPlacement="end"
                                        />
                                    </TableCell>
                                </TableRow>
                            ))}
                            <TableRow>
                                <TableCell colSpan={4} sx={{
                                    padding: '7px 12px',
                                    backgroundColor: '#DAEDFE',
                                    fontFamily: 'Roboto',
                                    fontSize: '12px',
                                    fontWeight: '600',
                                    color: '#444444',
                                }}>BOOKING OTHER DETAILS</TableCell>
                            </TableRow>
                            {BoookingOtherDetails.map((item, index) => (
                                <TableRow >
                                    <TableCell style={{ ...cellStyles, width: '25%' }}>
                                        {item.field}
                                    </TableCell>
                                    <TableCell style={{ ...cellStyles, width: '25%', justifyContent: 'center', textAlign: "center" }}>
                                        <FormControlLabel
                                            value="end"
                                            sx={{ marginX: '0px' }}
                                            control={
                                                <Checkbox
                                                    id={`paid-${index}`}
                                                    checked={editSaveData[item.isRemove] === 1}
                                                    onChange={(event) => {
                                                        handleBrnhCargoValue(event.target.checked ? 1 : 0, item.isRemove, [item.isDisable,item.isMandatory])
                                                    }}
                                                    sx={{
                                                        fontSize: '12px',
                                                        backgroundColor: 'transparent !important',
                                                        height: '36px',
                                                        verticalAlign: 'middle'
                                                    }}

                                                />
                                            }
                                            labelPlacement="end"
                                        />
                                    </TableCell>
                                    <TableCell style={{ ...cellStyles, width: '25%', justifyContent: 'center', textAlign: "center" }}>
                                        <FormControlLabel
                                            value="end"
                                            sx={{ marginX: '0px' }}
                                            control={
                                                <Checkbox
                                                    id={`paidManual-${index}`}
                                                    checked={editSaveData[item.isDisable] === 1}
                                                    onChange={(event) => {
                                                        handleBrnhCargoValue(event.target.checked ? 1 : 0, item.isDisable, [item.isRemove,item.isMandatory])
                                                    }}
                                                    sx={{
                                                        fontSize: '12px',
                                                        backgroundColor: 'transparent !important',
                                                        height: '36px',
                                                        verticalAlign: 'middle'
                                                    }}

                                                />
                                            }
                                            labelPlacement="end"
                                        />
                                    </TableCell>
                                    <TableCell style={{ ...cellStyles, width: '25%', justifyContent: 'center', textAlign: "center" }}>
                                        <FormControlLabel
                                            value="end"
                                            sx={{ marginX: '0px' }}
                                            control={
                                                <Checkbox
                                                    id={`toPay-${index}`}
                                                    checked={editSaveData[item.isMandatory] === 1}
                                                    onChange={(event) => {
                                                        handleBrnhCargoValue(event.target.checked ? 1 : 0, item.isMandatory, [item.isRemove,item.isDisable])
                                                    }}
                                                    sx={{
                                                        fontSize: '12px',
                                                        backgroundColor: 'transparent !important',
                                                        height: '36px',
                                                        verticalAlign: 'middle'
                                                    }}

                                                />
                                            }
                                            labelPlacement="end"
                                        />
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                    <Table stickyHeader size="small" style={{ width: '50%' }}>
                        <TableHead>
                            <TableRow style={{ background: '#DAEDFE' }}>
                                {bookingConfigColDefs.map((col, index) => (
                                    <TableCell
                                        key={`TH-L-${index}`}
                                        sx={{
                                            ...col.headerSx,
                                            padding: '7px 12px',
                                            backgroundColor: '#DAEDFE',
                                            fontFamily: 'Roboto',
                                            fontSize: '12px',
                                            fontWeight: '600',
                                            color: '#444444',
                                        }}
                                    >
                                        {col.headerName}
                                    </TableCell>
                                ))}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            <TableRow>
                                <TableCell colSpan={4} sx={{
                                    padding: '7px 12px',
                                    backgroundColor: '#DAEDFE',
                                    fontFamily: 'Roboto',
                                    fontSize: '12px',
                                    fontWeight: '600',
                                    color: '#444444',
                                }}>CONSIGNMENT DETAILS</TableCell>
                            </TableRow>
                            {ConsignmentDetails.map((item, index) => (
                                <TableRow >
                                    <TableCell style={{ ...cellStyles, width: '25%' }}>
                                        {item.field}
                                    </TableCell>
                                    <TableCell style={{ ...cellStyles, width: '25%', justifyContent: 'center', textAlign: "center" }}>
                                        <FormControlLabel
                                            value="end"
                                            sx={{ marginX: '0px' }}
                                            control={
                                                <Checkbox
                                                    id={`paid-${index}`}
                                                    checked={editSaveData[item.isRemove] === 1}
                                                    onChange={(event) => {
                                                        handleBrnhCargoValue(event.target.checked ? 1 : 0, item.isRemove, [item.isDisable,item.isMandatory])
                                                    }}
                                                    disabled={item.isCompalsary ||item.isRemove==0}
                                                    sx={{
                                                        fontSize: '12px',
                                                        backgroundColor: 'transparent !important',
                                                        height: '36px',
                                                        verticalAlign: 'middle'
                                                    }}

                                                />
                                            }
                                            labelPlacement="end"
                                        />
                                    </TableCell>
                                    <TableCell style={{ ...cellStyles, width: '25%', justifyContent: 'center', textAlign: "center" }}>
                                        <FormControlLabel
                                            value="end"
                                            sx={{ marginX: '0px' }}
                                            control={
                                                <Checkbox
                                                    id={`paidManual-${index}`}
                                                    checked={editSaveData[item.isDisable] === 1}
                                                    onChange={(event) => {
                                                        handleBrnhCargoValue(event.target.checked ? 1 : 0, item.isDisable, [item.isRemove,item.isMandatory])
                                                    }}
                                                    disabled={item.isCompalsary}
                                                    sx={{
                                                        fontSize: '12px',
                                                        backgroundColor: 'transparent !important',
                                                        height: '36px',
                                                        verticalAlign: 'middle'
                                                    }}

                                                />
                                            }
                                            labelPlacement="end"
                                        />
                                    </TableCell>
                                    <TableCell style={{ ...cellStyles, width: '25%', justifyContent: 'center', textAlign: "center" }}>
                                        <FormControlLabel
                                            value="end"
                                            sx={{ marginX: '0px' }}
                                            control={
                                                <Checkbox
                                                    id={`toPay-${index}`}
                                                    checked={editSaveData[item.isMandatory] === 1 || item.isMandatory===1 }
                                                    onChange={(event) => {
                                                        handleBrnhCargoValue(event.target.checked ? 1 : 0, item.isMandatory, [item.isRemove,item.isDisable])
                                                    }}
                                                    disabled={item.isCompalsary}
                                                    sx={{
                                                        fontSize: '12px',
                                                        backgroundColor: 'transparent !important',
                                                        height: '36px',
                                                        verticalAlign: 'middle'
                                                    }}

                                                />
                                            }
                                            labelPlacement="end"
                                        />
                                    </TableCell>
                                </TableRow>
                            ))}
                            <TableRow>
                                <TableCell colSpan={4} sx={{
                                    padding: '7px 12px',
                                    backgroundColor: '#DAEDFE',
                                    fontFamily: 'Roboto',
                                    fontSize: '12px',
                                    fontWeight: '600',
                                    color: '#444444',
                                }}>BOOKING OTHER CHARGES</TableCell>
                            </TableRow>
                            {BookingOtherCharges.map((item, index) => (
                                <TableRow >
                                    <TableCell style={{ ...cellStyles, width: '25%' }}>
                                        {item.field}
                                    </TableCell>
                                    <TableCell style={{ ...cellStyles, width: '25%', justifyContent: 'center', textAlign: "center" }}>
                                        <FormControlLabel
                                            value="end"
                                            sx={{ marginX: '0px' }}
                                            control={
                                                <Checkbox
                                                    id={`paid-${index}`}
                                                    checked={editSaveData[item.isRemove] === 1}
                                                    onChange={(event) => {
                                                        handleBrnhCargoValue(event.target.checked ? 1 : 0, item.isRemove, [item.isDisable,item.isMandatory])
                                                    }}
                                                    sx={{
                                                        fontSize: '12px',
                                                        backgroundColor: 'transparent !important',
                                                        height: '36px',
                                                        verticalAlign: 'middle'
                                                    }}

                                                />
                                            }
                                            labelPlacement="end"
                                        />
                                    </TableCell>
                                    <TableCell style={{ ...cellStyles, width: '25%', justifyContent: 'center', textAlign: "center" }}>
                                        <FormControlLabel
                                            value="end"
                                            sx={{ marginX: '0px' }}
                                            control={
                                                <Checkbox
                                                    id={`paidManual-${index}`}
                                                    checked={editSaveData[item.isDisable] === 1}
                                                    onChange={(event) => {
                                                        handleBrnhCargoValue(event.target.checked ? 1 : 0, item.isDisable, [item.isRemove,item.isMandatory])
                                                    }}
                                                    sx={{
                                                        fontSize: '12px',
                                                        backgroundColor: 'transparent !important',
                                                        height: '36px',
                                                        verticalAlign: 'middle'
                                                    }}

                                                />
                                            }
                                            labelPlacement="end"
                                        />
                                    </TableCell>
                                    <TableCell style={{ ...cellStyles, width: '25%', justifyContent: 'center', textAlign: "center" }}>
                                        <FormControlLabel
                                            value="end"
                                            sx={{ marginX: '0px' }}
                                            control={
                                                <Checkbox
                                                    id={`toPay-${index}`}
                                                    checked={editSaveData[item.isMandatory] === 1}
                                                    onChange={(event) => {
                                                        handleBrnhCargoValue(event.target.checked ? 1 : 0, item.isMandatory, [item.isRemove,item.isDisable])
                                                    }}
                                                    sx={{
                                                        fontSize: '12px',
                                                        backgroundColor: 'transparent !important',
                                                        height: '36px',
                                                        verticalAlign: 'middle'
                                                    }}

                                                />
                                            }
                                            labelPlacement="end"
                                        />
                                    </TableCell>
                                </TableRow>
                            ))}
                            <TableRow>
                                <TableCell colSpan={4} sx={{
                                    padding: '7px 12px',
                                    backgroundColor: '#DAEDFE',
                                    fontFamily: 'Roboto',
                                    fontSize: '12px',
                                    fontWeight: '600',
                                    color: '#444444',
                                }}>INSURANCE / VALUATION PROVIDER</TableCell>
                            </TableRow>
                            <TableRow >
                                <TableCell style={{ ...cellStyles, width: '25%' }}>
                                    OPERATOR
                                </TableCell>
                                <TableCell style={{ ...cellStyles, width: '25%', justifyContent: 'center', textAlign: "center" }}>
                                    <Radio
                                        //   id={el.TripID + 'radio'}
                                        name="insuranceProvider"
                                        checked={editSaveData?.InsuranceProviderID === 1}
                                        onChange={() =>setEditSaveData((prev) => ({...prev,InsuranceProviderID: 1}))}
                                        disabled={editSaveData['RemoveValuation'] === 1}
                                        size={'medium'}
                                    //   ref={(radio) => (radioRefs.current[index] = radio)}
                                    //   onKeyDown={(e) => handleKeyDown(e, onCloseCallback)}
                                    />
                                </TableCell>
                                <TableCell style={{ ...cellStyles, width: '25%', textAlign: "left" }}>
                                    BHARTI AXA
                                </TableCell>
                                <TableCell style={{ ...cellStyles, width: '25%', justifyContent: 'center', textAlign: "center" }}>
                                    <Radio
                                        //   id={el.TripID + 'radio'}
                                        name="insuranceProvider"
                                        checked={editSaveData?.InsuranceProviderID !== 1}
                                        onChange={() =>
                                            setEditSaveData((prev) => ({...prev,InsuranceProviderID: 2}))
                                        }
                                        disabled={editSaveData['RemoveValuation'] === 1}
                                        size={'medium'}
                                    //   ref={(radio) => (radioRefs.current[index] = radio)}
                                    //   onKeyDown={(e) => handleKeyDown(e, onCloseCallback)}
                                    />
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell colSpan={4} sx={{
                                    padding: '7px 12px',
                                    backgroundColor: '#DAEDFE',
                                    fontFamily: 'Roboto',
                                    fontSize: '12px',
                                    fontWeight: '600',
                                    color: '#444444',
                                }}>GST TYPE CONFIG</TableCell>
                            </TableRow>
                            {GSTTypeConfig.map((item, index) => (
                                <TableRow >
                                    <TableCell style={{ ...cellStyles, width: '25%' }}>
                                        {item.leftLabel}
                                    </TableCell>
                                    <TableCell style={{ ...cellStyles, width: '25%', justifyContent: 'center', textAlign: "center" }}>
                                        {
                                            item.type === 'checkboxRow' ?
                                                <FormControlLabel
                                                    value="end"
                                                    sx={{ marginX: '0px' }}
                                                    control={
                                                        <Checkbox
                                                            id={`paid-${index}`}
                                                            checked={!!editSaveData?.[item.leftValue]}
                                                            onChange={(e) =>
                                                                setEditSaveData((prev) => ({
                                                                    ...prev,
                                                                    [item.leftValue]: e.target.checked ? 1 : 0,
                                                                }))
                                                            }
                                                            sx={{
                                                                fontSize: '12px',
                                                                backgroundColor: 'transparent !important',
                                                                height: '36px',
                                                                verticalAlign: 'middle'
                                                            }}

                                                        />
                                                    }
                                                    labelPlacement="end"
                                                /> : <Radio
                                                    checked={editSaveData?.[item.leftValue] === (item.leftValue === "GstType" ? 2 : 1)}
                                                    onChange={() =>
                                                        setEditSaveData((prev) => ({
                                                            ...prev,
                                                            [item.leftValue]: item.leftValue === "GstType" ? 2 : 1,
                                                        }))
                                                    }
                                                    name={item.leftValue}
                                                    size={'medium'}
                                                //   ref={(radio) => (radioRefs.current[index] = radio)}
                                                //   onKeyDown={(e) => handleKeyDown(e, onCloseCallback)}
                                                />
                                        }
                                    </TableCell>
                                    <TableCell style={{ ...cellStyles, width: '25%', justifyContent: 'left', textAlign: "left" }}>
                                        {item.rightLabel}
                                    </TableCell>
                                    <TableCell style={{ ...cellStyles, width: '25%', justifyContent: 'center', textAlign: "center" }}>
                                        {
                                            item.type === 'checkboxRow' ?
                                                <FormControlLabel
                                                    value="end"
                                                    sx={{ marginX: '0px' }}
                                                    control={
                                                        <Checkbox
                                                            id={`paid-${index}`}
                                                            checked={!!editSaveData?.[item.rightValue]}
                                                            onChange={(e) =>
                                                                setEditSaveData((prev) => ({
                                                                    ...prev,
                                                                    [item.rightValue]: e.target.checked ? 1 : 0,
                                                                }))
                                                            }
                                                            sx={{
                                                                fontSize: '12px',
                                                                backgroundColor: 'transparent !important',
                                                                height: '36px',
                                                                verticalAlign: 'middle'
                                                            }}

                                                        />
                                                    }
                                                    labelPlacement="end"
                                                /> : <Radio
                                                    //   id={el.TripID + 'radio'}
                                                    checked={editSaveData?.[item.rightValue] === (item.rightValue === "GstType" ? 1 : 2)}
                                                    onChange={() =>
                                                        setEditSaveData((prev) => ({
                                                            ...prev,
                                                            [item.rightValue]: item.rightValue === "GstType" ? 1 :2,
                                                        }))
                                                    }
                                                    name={item.rightValue}
                                                    size={'medium'}
                                                //   ref={(radio) => (radioRefs.current[index] = radio)}
                                                //   onKeyDown={(e) => handleKeyDown(e, onCloseCallback)}
                                                />
                                        }
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Box>
            {openEwayBillModel ? handleEwayBillConfig() : null}
        </>
    )
}

export default BookingScreenConfig